export enum EMarqueMultimetre {
    TESTO = 1,
    KIMO,
    TSI
}